import React from "react";
import { Section, FadeUp, SectionHeading, CheckItem } from "./primitives";
import { forYou, notForYou } from "@/data/content";

export const WhoFor = () => (
  <Section className="bg-white">
    <div className="max-w-[1100px] mx-auto">
      <FadeUp className="text-center max-w-[720px] mx-auto">
        <SectionHeading>Who Lead Guitar Freedom Is For</SectionHeading>
      </FadeUp>
      <div className="mt-12 grid gap-6 md:grid-cols-2">
        <FadeUp>
          <div className="h-full bg-zinc-50 border border-zinc-200 rounded-xl p-8 md:p-10">
            <h3 className="text-xl font-bold text-zinc-900">This Is For You If&hellip;</h3>
            <ul className="mt-6 space-y-4">
              {forYou.map((item) => (
                <CheckItem key={item} variant="check">{item}</CheckItem>
              ))}
            </ul>
          </div>
        </FadeUp>
        <FadeUp delay={0.05}>
          <div className="h-full bg-zinc-50 border border-zinc-200 rounded-xl p-8 md:p-10">
            <h3 className="text-xl font-bold text-zinc-900">This Is Not For You If&hellip;</h3>
            <ul className="mt-6 space-y-4">
              {notForYou.map((item) => (
                <CheckItem key={item} variant="cross">{item}</CheckItem>
              ))}
            </ul>
          </div>
        </FadeUp>
      </div>
    </div>
  </Section>
);
